// extracted by mini-css-extract-plugin
module.exports = {"DetailedProfileCards":"DetailedProfileCards_DetailedProfileCards__dguOg","DetailedProfileCards__card":"DetailedProfileCards_DetailedProfileCards__card__KMh7q"};